import { createFileRoute } from '@tanstack/react-router';
import { parseCountsSearch, type CountsSearch } from '@/features/stock/counts-search';
import { CountsPage } from '@/features/stock/counts-page';

export const Route = createFileRoute('/_app/stock/counts/')({
  // the state chip, the warehouse menu and the "Sayım başlat" drawer live in the
  // URL, so a filtered list can be pasted to the other partner (§5)
  validateSearch: (s: Record<string, unknown>): CountsSearch => parseCountsSearch(s),
  component: function Counts() {
    return <CountsPage search={Route.useSearch()} />;
  },
});
